import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  SmartphoneNfc, 
  RefreshCcw, 
  CheckCircle2, 
  XCircle,
} from 'lucide-react';
import Navbar from '../../components/Navbar';
import SubscriptionRequest from '../../requests/vendor/SubscriptionRequest';
const VerifyPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(false);
  const { transactionId, paymentDetails, attempts } = location.state || {};

  const handleManualVerification = async () => {
    setIsVerifying(true);
    try {
      const response = await SubscriptionRequest.verifySubscription(transactionId);
      await new Promise(resolve => setTimeout(resolve, 2000));
      const status = response?.data?.data?.status;

      if (status === 'completed') {
        navigate('/payment/success', { 
          state: { transactionId, paymentDetails } 
        });
      }
      if(status === "failed"){
        navigate('/payment/failed', {
          state: { transactionId, paymentDetails } 
        });
      }
      else {
        setIsVerifying(false);
      }
    } catch (err) {
      setIsVerifying(false);
    }
  };

  const handleCancel = () => {
    navigate('/payment/failed', { 
      state: { transactionId, paymentDetails } 
    });
  };

  if (!transactionId) {
    return navigate('/');
  }

  return (
    <>
<Navbar/>
    <div className="min-h-screen bg-gray-50">
      <div className="px-4 py-16 mx-auto max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="p-8 bg-white rounded-3xl shadow-xl"
        >
          <div className="space-y-6 text-center">
            <div className="flex justify-center">
              <div className="flex justify-center items-center w-20 h-20 bg-yellow-100 rounded-full">
                <SmartphoneNfc className="w-10 h-10 text-yellow-600" />
              </div>
            </div>

            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-gray-900">
                Payment Verification Required
              </h1>
              <p className="text-gray-600">
                We couldn't automatically verify your payment after {attempts} attempts.
                Please check your phone for the payment prompt and approve the transaction.
              </p>
            </div>

            <div className="p-6 space-y-2 bg-gray-50 rounded-xl">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Transaction ID</span>
                <span className="font-medium text-gray-900">{transactionId}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Amount</span>
                <span className="font-medium text-gray-900">
                  GH₵{parseFloat(paymentDetails.price).toFixed(2)}
                </span>
              </div>
            </div>

            <div className="space-y-4">
              <button
                onClick={handleManualVerification}
                disabled={isVerifying}
                className={`
                  w-full py-4 rounded-xl font-semibold transition-all duration-300
                  ${isVerifying
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-[#FF6C6C] text-white hover:bg-[#ff5555] shadow-lg hover:shadow-xl'
                  }
                `}
              >
                <span className="flex justify-center items-center space-x-2">
                  {isVerifying ? (
                    <>
                      <RefreshCcw className="w-5 h-5 animate-spin" />
                      <span>Verifying...</span>
                    </>
                  ) : (
                    <>
                      <CheckCircle2 className="w-5 h-5" />
                      <span>I Have Paid</span>
                    </>
                  )}
                </span>
              </button>

              <button
                onClick={handleCancel}
                className="py-4 w-full font-semibold text-gray-600 bg-gray-100 rounded-xl transition-all duration-300 hover:bg-gray-200"
              >
                <span className="flex justify-center items-center space-x-2">
                  <XCircle className="w-5 h-5" />
                  <span>Cancel Payment</span>
                </span>
              </button>
            </div>

            <p className="text-sm text-gray-500">
              Need help? Contact our support team for assistance.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
    </>
  );
};

export default VerifyPayment; 